const img = require('./porchSideD.svg'); export default img;